import React, { useCallback, useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import { useQuery } from "react-query";
import axios from "../../../api/axios";
import { skuDataUrl, postNewSKU } from "../../../api/endPoints";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import MaterialTable from "../Tables/MaterialTable";
import { db } from "../../../api/firebase";
import {
  getDoc,
  collection,
  addDoc,
  Timestamp,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  setDoc,
} from "firebase/firestore";
import { useAppSelector } from "../../../utils/hooks";
import { usersData } from "../../../store/reducer/usersSlice";
import { nbfUsers } from "../../../api/restApi";
import { setUsers } from "../../../store/reducer/usersSlice";
import { useDispatch } from "react-redux";
import { useAppDispatch } from "../../../utils/hooks";

const UserManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const { users } = useAppSelector(usersData);
  console.log(users)
  const dispatch = useAppDispatch();
  const collectionName = "Users";

  const nbfUserInfo = async () => {
    let users = await nbfUsers();
    dispatch(setUsers(users));
  };
  // useEffect(()=>{
  //   nbfUserInfo()
  // },[])
  console.log(users);
  const handleCreateNewRow = async (values) => {
    try {
      if (!values || Object.keys(values).length === 0) {
        alert("Please enter valid data");
        return;
      }

      await addDoc(collection(db, collectionName), values);
      // console.log(response);
      // const docRef = doc(collection(db, collectionName), "id");
      // await setDoc(docRef, values);
      toast.success("Successfully add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      nbfUserInfo();
    } catch (error) {
      // console.log(error);
      console.log(error);
      toast.error("Failed to add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  useEffect(() => {});
  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    // if (!Object.keys(validationErrors).length) {

    try {
      let id = row.getValue("id").toString();
      await updateDoc(doc(db, collectionName, id), values);

      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      nbfUserInfo();
    } catch (error) {
      // console.log(error);
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }

    exitEditingMode(); //required to exit editing mode and close modal
    // }
  };

  // const handleDeleteRow = useCallback(
  //   async (row) => {

  //     if (
  //       !window.confirm(
  //         `Are you sure you want to delete ${row.getValue("Name")}`
  //       )
  //     ) {
  //       return;
  //     }
  //   },
  // );
  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      size: 80,
    },
    {
      accessorKey: "name",
      header: "Name",
      size: 140,
    },
    {
      accessorKey: "email",
      header: "Email",
      size: 140,
    },
    {
      accessorKey: "phone",
      header: "Phone",
      size: 140,
    },
    {
      accessorKey: "address",
      header: "Address",
      size: 140,
    },
  ]);

  return (
    <>
      <Stack spacing={4} marginX={4} mt={1}>
        <MaterialTable
          setCreateModalOpen={setCreateModalOpen}
          tableData={users}
          handleSaveRowEdits={handleSaveRowEdits}
          //   handleCancelRowEdits={handleCancelRowEdits}
          //   handleDeleteRow={handleDeleteRow}
          columns={columns}
          csvFileName="users"
        ></MaterialTable>
      </Stack>
      <CreateNewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
      />
    </>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit }) => {
  const initialValues = {
    // Address: '',
    // City: '',
    // Name: '',
    // id: '',
    // Email: ''
  };
  const [values, setValues] = useState(initialValues);

  // useEffect(() => {
  //   setValues(initialValues);
  // }, []);

  const handleSubmit = async () => {
    onSubmit(values);
    onClose();
  };

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Create New Product</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "300px", sm: "360px", md: "400px" },
              gap: "1.5rem",
            }}
          >
            {columns.map((column) => {
              // Remove columns from new update
              if (column.accessorKey !== "id") {
                return (
                  <TextField
                    key={column.accessorKey}
                    label={column.header}
                    name={column.accessorKey}
                    onChange={(e) =>
                      setValues({ ...values, [e.target.name]: e.target.value })
                    }
                  />
                );
              }
            })}
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={handleSubmit} variant="contained">
          Create New Customer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserManagement;
